module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-credit-records"
  }, [_c('ActionBar', [_c('h2', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.type) + " Credit")]), (_vm.expanded) ? _c('i', {
    staticClass: "fa fa-plus-circle fa-2x",
    attrs: {
      "slot": "action"
    },
    on: {
      "click": function($event) {
        _vm.addCredit = !_vm.addCredit
      }
    },
    slot: "action"
  }) : _vm._e(), _c('i', {
    staticClass: "fa fa-2x",
    class: {
      'fa-eye-slash': _vm.expanded, 'fa-eye': !_vm.expanded
    },
    attrs: {
      "slot": "action"
    },
    on: {
      "click": function($event) {
        _vm.expanded = !_vm.expanded
      }
    },
    slot: "action"
  })]), (_vm.addCredit) ? _c('div', {
    staticClass: "add-credit"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Amount Vat Included"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.amount),
      expression: "body.amount"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.body.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "amount", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Reason"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.reason),
      expression: "body.reason"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.body.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "reason", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Tax"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.tax),
      expression: "body.tax"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.body.tax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "tax", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Service"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.service),
      expression: "body.service"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "service", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All")]), _c('option', [_vm._v("Reservation")]), _c('option', [_vm._v("Subscription")])])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Valid from"), _c('DatePicker', {
    model: {
      value: (_vm.body.valid_from),
      callback: function($$v) {
        _vm.$set(_vm.body, "valid_from", $$v)
      },
      expression: "body.valid_from"
    }
  })], 1)]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Valid to"), _c('DatePicker', {
    model: {
      value: (_vm.body.valid_to),
      callback: function($$v) {
        _vm.$set(_vm.body, "valid_to", $$v)
      },
      expression: "body.valid_to"
    }
  })], 1)])]), _c('ActionButton', {
    attrs: {
      "action": _vm.addNewCredit
    }
  }, [_vm._v("Add Credit")])], 1) : _vm._e(), (_vm.expanded) ? _c('base-list', {
    ref: "listCr",
    attrs: {
      "component": _vm.component,
      "search": _vm.search,
      "dataLoader": _vm.dataLoader,
      "resultsPerPage": 5,
      "componentType": "listing"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ef9a9d86!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/CreditRecords.vue
// module id = 2745
// module chunks = 1